import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'discipline-conduct',
  templateUrl: './discipline-conduct.component.html',
  styleUrls: ['./discipline-conduct.component.css']
})
export class DisciplineConductComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
